import type { Goal } from 'app-components/flux/goals/goalsTypes';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { specificGoalType } from 'components/Dialogs/Goals/AddGoal/state';
import { Map as ImmutableMap } from 'immutable';

export const WITHDRAW_FROM_GOAL_DIALOG_TYPE = 'WITHDRAW_FROM_GOAL_DIALOG';
export const withdrawFromGoalDialog = (goal: Goal) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      type: WITHDRAW_FROM_GOAL_DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({
        goal,
      }),
    }),
  );

export const CONTRIBUTE_TO_GOAL_DIALOG_TYPE = 'CONTRIBUTE_TO_GOAL_DIALOG';
export const contributeToGoalDialog = (goal: Goal, context?: string, selectedDate?: string | null) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      type: CONTRIBUTE_TO_GOAL_DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({
        goal,
        context,
        selectedDate,
      }),
    }),
  );

export const ADD_GOAL_DIALOG_TYPE = 'ADD_GOAL_DIALOG';
export const addGoalDialog = (context: string, name?: string, type?: specificGoalType) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      type: ADD_GOAL_DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({ context, type, name }),
    }),
  );
